import * as actionTypes from "../action-types";

const initialState = {
    horoscopeData: null,
    AsthakootaData: null,
    AstroData: null
};

const astrologyApiReducer = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        //! Horoscope
        case actionTypes.SET_HOROSCOPE:
            return { ...state, horoscopeData: payload };

        //! Kundli Matching
        case actionTypes.SET_ASTHAKOOTA:
            return { ...state, AsthakootaData: payload };

        case actionTypes.SET_ASTRO_DATA:
            return { ...state, AstroData: payload };

        default:
            return state;
    }
};

export default astrologyApiReducer;